import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { DeviceAcceptanceStatesService } from 'app/services/models/device-acceptance-states.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-device-acceptance-states-list',
  templateUrl: './device-acceptance-states-list.component.html',
  styleUrls: ['./device-acceptance-states-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DeviceAcceptanceStatesListComponent implements OnInit {
  @BlockUI('section-block') blockUI: NgBlockUI;
  rows: any[] = [];
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption = 5;
  public searchValue = '';
  totalCount: number = 0;
  public ColumnMode = ColumnMode;

  name: string = null;

  constructor(
    private deviceAcceptanceStatesService: DeviceAcceptanceStatesService,
    private toastrService: ToastrService
  ) { }

  async ngOnInit() {
    await this.getAllDeviceAccaptanceService(this.pageBasic - 1, this.selectedSize)
  }

  async getAllDeviceAccaptanceService(page, size) {
    const data = await this.deviceAcceptanceStatesService.getAllDeviceAcceptanceStates(page, size);
    console.log(data);
    this.rows = data.deviceAcceptances;
    this.totalCount = data.totalCount;
  }

  async onOptionChange() {
    this.selectedSize = Number(this.basicSelectedOption);
    await this.getAllDeviceAccaptanceService(this.pageBasic - 1, this.selectedSize);
  }

  async onPageChange() {
    await this.getAllDeviceAccaptanceService(this.pageBasic - 1, this.selectedSize);
  }


  async deviceAcceptanceStatesCreate() {
    console.log("Girilen Değer:", this.name);
    if (this.name) {
      const data = await this.deviceAcceptanceStatesService.createDeviceAcceptanceStates(this.name);
      if (data.status) {
        this.toastrService.success(data.message);
        await this.getAllDeviceAccaptanceService(this.pageBasic - 1, this.selectedSize);
      } else {
        this.toastrService.error(data.message);
      }
    }
  }

  editingRowId: number | null = null;
  async saveRow(id: number) {
    this.editingRowId = null;
    const row = this.rows.find(row => row.id === id);
    if (row) {
      console.log('Saved:', row.id, row.name);
      const data = await this.deviceAcceptanceStatesService.updateDeviceAcceptanceStates(row.id, row.name);
      console.log(data)
      if (data.status) {
        await this.getAllDeviceAccaptanceService(this.pageBasic - 1, this.selectedSize);
        this.toastrService.success(data.message);
      } else {
        this.toastrService.error(data.message);
      }
    }
  }

  cancelEdit(id: number) {
    this.editingRowId = null;
  }

  isEditingRow(id: number): boolean {
    return this.editingRowId === id;
  }

  editRow(id: number) {
    this.editingRowId = id;
    const row = this.rows.find(row => row.id === id);
    if (row) {
      console.log('Editing:', row.id, row.name);
    }
  }

}